import { Route, Routes, useLocation } from 'react-router-dom';
import { WorkforceActiveJobDetails } from '../../pages/Workforce/WorkforceActiveJobDetails.jsx';
import { WorkforceActiveJobOpenings } from '../../pages/Workforce/WorkforceActiveJobOpenings';
import { WorkforceHome } from '../../pages/Workforce/WorkforceHome';
import { WorkforceMyActiveJobBids } from '../../pages/Workforce/WorkforceMyActiveJobBids.jsx';
import { WorkforceMyJobBidsHistory } from '../../pages/Workforce/WorkforceMyJobBidsHistory.jsx';
import { WorkforceMyJobBidsHistoryDetails } from '../../pages/Workforce/WorkforceMyJobBidsHistoryDetails.jsx';
import { WorkforceMyJobBidsWithdraw } from '../../pages/Workforce/WorkforceMyJobBidsWithdraw.jsx';
import { SupportRequestPage } from '../../pages/SupportRequestPage';
import { AnchorLink } from './AnchorLink.jsx';
import { SecureRoute } from './SecureRoute';

export const useWorkforceNavigationItems = () => {
    const location = useLocation();

    const createLink = (label, url) => {
        return {
            component: AnchorLink,
            href: url,
            selected: location.pathname === url,
            label,
        };
    };

    return [
        createLink('Home', '/'),
        createLink('Active Job Openings', '/active-job-openings'),
        createLink('My Job Bids', '/my-job-bids'),
        createLink('Bid History', '/my-bid-history'),
    ];
};

export const WorkforceRoutes = () => {
    return (
        <Routes>
            <Route
                path="/active-job-openings"
                element={
                    <SecureRoute>
                        <WorkforceActiveJobOpenings />
                    </SecureRoute>
                }
            />
            <Route
                path="/active-job-openings/:jobNumber"
                element={
                    <SecureRoute>
                        <WorkforceActiveJobDetails />
                    </SecureRoute>
                }
            />
            <Route
                path="/my-job-bids"
                element={
                    <SecureRoute>
                        <WorkforceMyActiveJobBids />
                    </SecureRoute>
                }
            />
            <Route
                path="/my-job-bids/:jobNumber"
                element={
                    <SecureRoute>
                        <WorkforceMyJobBidsWithdraw />
                    </SecureRoute>
                }
            />
            <Route
                path="/my-bid-history"
                element={
                    <SecureRoute>
                        <WorkforceMyJobBidsHistory />
                    </SecureRoute>
                }
            />
            <Route
                path="/my-bid-history/details/:jobNumber"
                element={
                    <SecureRoute>
                        <WorkforceMyJobBidsHistoryDetails />
                    </SecureRoute>
                }
            />
            <Route
                path="/support-request"
                element={
                    <SecureRoute>
                        <SupportRequestPage />
                    </SecureRoute>
                }
            />
            <Route
                path="/*"
                element={
                    <SecureRoute>
                        <WorkforceHome />
                    </SecureRoute>
                }
            />
        </Routes>
    );
};
